import {
  IndexDemoChatBoxContainer,
  IndexDemoComponenChatContent,
  IndexDemoComponentDemoContainerDiv,
  IndexDemoComponentDemoContent,
  IndexDemoComponentMainDiv,
  IndexDemoComponentUseCaseDiv,
  IndexDemoComponentUseCaseItemDiv,
} from "../../styles/indexcomponentsstyles/indexdemocomponentstyles";
import logo from "./assets/bugzi logo 2.png";
import { ReactComponent as ChatIcon } from "./assets/comment-regular-full.svg";
import { ReactComponent as NewIcon } from "./assets/plus-solid-full.svg";
import { ReactComponent as UserIcon } from "./assets/user-solid-full.svg";
import { ReactComponent as LogoutIcon } from "./assets/right-from-bracket-solid-full.svg";
import { ReactComponent as LightmodeIcon } from "./assets/sun-solid-full.svg";
import ButtonComponent from "../reusable/header/assetes/buttoncomponents/butttoncomponent";

import { ReactComponent as OpenAiIcon } from "./assets/openai-brands-solid-full.svg";
import { ReactComponent as DropDownIcon } from "./assets/angle-down-solid-full.svg";
import { ReactComponent as BrainIcon } from "./assets/brain-solid-full.svg";
import { ReactComponent as Bookicon } from "./assets/book-solid-full.svg";
import { ReactComponent as Bugicon } from "./assets/bug-solid-full.svg";
import { ReactComponent as Changesicon } from "./assets/code-compare-solid-full.svg";
import { ReactComponent as Codebaseicon } from "./assets/laptop-code-solid-full.svg";
import { ReactComponent as Appicon } from "./assets/app-store-ios-brands-solid-full.svg";
import { useEffect, useState } from "react";
import ShinyGradient from "../reusable/svg/shinygradient";
const IndexDemoComponent = () => {
  const [chatText, setChatText] = useState("");
  const [activeMessage, setActiveMessage] = useState<number>(0);
  const [isWaiting, setIsWaiting] = useState(false);
  const [messages, setMessages] = useState<Array<string>>([]);

  const [text,] = useState("Start a New Chat..");

  const typingSpeed = 150;
  const pauseTime = 2000;

  useEffect(() => {

    const chatmessages =
      [
        " Review this code for errors.",
        "Code‑review agent activated, scanning and highlighting issues.",

        " Fix the bug in line 42.",
        " Error‑fixing agent applied corrective logic automatically.",

        " Improve the clarity of this paragraph.",
        " Writing agent optimized style and polished the text.",

        " Search for supporting references online.",
        " Browser agent collected sources and summarized findings.",

        " Edit the configuration file.",
        "File‑editing agent adjusted parameters and saved changes.",

        " Run the workflow end‑to‑end.",
        "Coordinated all agents in sequence for a unified result."
      ]

    const i = activeMessage % chatmessages.length;
    const fullText = chatmessages[i];
    setMessages(chatmessages.slice(0, i + 1));

    const handleType = () => {
      setChatText((current) => {
        if (isWaiting) {
          return fullText;
        } else {
          return fullText.substring(0, current.length + 1);
        }
      });
    };
    const handleNewChat = () => {
      setActiveMessage((prev) => prev + 1);
      if (activeMessage >= chatmessages.length - 1) {
        setActiveMessage(0);
      }

      setChatText("");

      setMessages(chatmessages.slice(0, i + 1));
      setIsWaiting(false);

      timer = setTimeout(handleType, pauseTime);
    };

    let timer: ReturnType<typeof setTimeout>;

    if (isWaiting) {
      timer = setTimeout(() => handleNewChat(), pauseTime);
    } else {
      if (chatText === fullText) {
        timer = setTimeout(() => setIsWaiting(true), pauseTime);
      } else {
        timer = setTimeout(handleType, typingSpeed);
      }
    }
    return () => clearTimeout(timer);
  }, [activeMessage, chatText, isWaiting]);

  return (
    <IndexDemoComponentMainDiv>
      <ShinyGradient/>
      <div>
        <div className="index-demo-trigger"></div>
        <div className="index-demo-container">
          <div className="index-demo-header-container">
            <div className="index-demo-ai-header-container">
              <div>
                {" "}
                <div>
                  {" "}
                  <div className="index-demo-ai-header-icon-holder">
                    <img src={logo} alt="" />
                  </div>
                </div>
              </div>
              <div>
                {" "}
                <div className=" index-demo-ai-header-text-holder">
                  <h2>AI</h2>
                </div>
              </div>
            </div>
            <div>
              {" "}
              <div className=" index-demo-ai-header-text-holder">
                <h2 className="index-demo-ai-header-powered-text">
                  <span className="index-demo-ai-header-powered-text-holder">
                    {" "}
                    Powered
                  </span>{" "}
                </h2>
              </div>
            </div>
          </div>
          <div className="index-demo-container">
            <IndexDemoComponentDemoContainerDiv>
              <div>
                <div>
                  <IndexDemoComponentDemoContent>
                    <div>
                      <div className="window-frame">
                        <div className="sidebar">
                          <div className="modal-header-holder ">
                            <div className="close-modal">
                              <div />
                              <div />
                              <div />
                            </div>
                            <div className="demo-modal-header">
                              <div className="dashboard-logo-header">
                                <div className="dashboard-logo-holder">
                                  <img src={logo} alt="bug"></img>
                                </div>
                                <div className="header-text">
                                  <h4> Bugzi AI</h4>
                                </div>
                              </div>
                              <div>
                                <div className="collapse-icon-holder"></div>
                              </div>
                            </div>

                            <div className="dashboard-new-chat-button">
                              <div>
                                <div className="new-icon-holder">
                                  <NewIcon
                                    className="small"
                                    fill="white"
                                  />{" "}
                                </div>
                                <div>New chat</div>
                              </div>
                            </div>
                          </div>
                          <div className="chat-sidebar-item-container">
                            <div className="chat-history-modal">
                              {chathistorydata.map((item, index) => (
                                <div
                                  className="chat-modal"
                                  key={index + "chat"}
                                >
                                  <div className="chat-modal-icon-holder">
                                    <ChatIcon
                                      className="icon-medium"
                                      fill=" #e3e3e3ff"
                                    ></ChatIcon>
                                  </div>
                                  <div>
                                    <p className="chat-modal-text">{item} </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="chat-modal-dasboard actions">
                              <div>
                                <div className=" chat-sidebar-action-container">
                                  <div>
                                    <div className="chat-sidebar-action-icon-container">
                                      <UserIcon fill="white" />
                                    </div>
                                  </div>
                                  <div>
                                    <div className="chat-sidebar-action-text-container">
                                      <p> My account </p>
                                    </div>
                                  </div>
                                </div>
                                <div className=" chat-sidebar-action-container">
                                  <div>
                                    <div className="chat-sidebar-action-icon-container">
                                      <LightmodeIcon fill="white" />
                                    </div>
                                  </div>
                                  <div>
                                    <div className="chat-sidebar-action-text-container">
                                      <p> Light mode</p>
                                    </div>
                                  </div>
                                </div>
                                <div className=" chat-sidebar-action-container">
                                  <div>
                                    <div className="chat-sidebar-action-icon-container">
                                      <LogoutIcon fill="white" />
                                    </div>
                                  </div>
                                  <div>
                                    <div className="chat-sidebar-action-text-container">
                                      <p> Log out </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="right">
                          <div className="test">
                            <div className="chat-bubble-container ">
                            {messages.map((item, index) => (
                              <IndexDemoComponenChatContent
                                isuser={(index + 1) % 2 > 0}
                                isactive={activeMessage === index}
                              >
                                <div>
                                  <div>
                                    <div className="chat-bubble-chat-icon-container ai-icon">
                                      <img src={logo} alt="AI" />{" "}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="chat-bubble-chat-container">
                                      <div className="chat-bubble-chat-text-container">
                                        <p>
                                          {activeMessage === index
                                            ? chatText
                                            : item}

                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                    <div className="chat-bubble-chat-icon-container user-icon">
                                      <img src={logo} alt="AI" />{" "}
                                    </div>
                                  </div>
                                </div>
                              </IndexDemoComponenChatContent>
                            ))}
                          </div>
                          </div>
                          
                          <div className="demo-input-container">
                            <IndexDemoChatBoxContainer>
                              <div className="chat-modal-container">
                                <div>
                                  <div className="chat-modal-content-holder">
                                    <div className="background-fill" />
                                    <div className="chat-modal-content">
                                      <div className="chat-modal-content-section">
                                        <div>
                                          <div className="chat-modal-model-selector">
                                            <div className="icon-container">
                                              <div>
                                                <OpenAiIcon className="openai" />
                                              </div>
                                            </div>
                                            <div className="model-text-wrapper">
                                              <p>GPT 5.5</p>
                                            </div>
                                            <div className="icon-container">
                                              <div>
                                                <DropDownIcon className="small" />{" "}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="chat-modal-selector">
                                            <div className="icon-container">
                                              <div>
                                                <BrainIcon className="small" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="chat-modal-content-section">
                                        <span className="chat-modal-input-text">
                                          <span className="typing-span">
                                            {text}
                                          </span>

                                        </span>
                                      </div>
                                      <div className="chat-modal-content-section">
                                        <div className="chat-modal-action-holder">
                                          <div className="chat-modal-action-container">
                                            <div className=" chat-modal-selector chat-modal-selector-large-padding">
                                              <div className="text-wrapper">
                                                <p>Chat</p>
                                              </div>
                                            </div>
                                            <div className=" chat-modal-selector chat-modal-selector-large-padding">
                                              <div className="text-wrapper">
                                                <p>Launch workflow</p>
                                              </div>
                                            </div>{" "}
                                            <div className=" chat-modal-selector chat-modal-selector-large-padding">
                                              <div className="text-wrapper">
                                                <p>Data Analysis</p>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <ButtonComponent
                                              title="send"
                                              icon={
                                                <OpenAiIcon
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                ></OpenAiIcon>
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </IndexDemoChatBoxContainer>
                          </div>
                        </div>
                      </div>
                    </div>
                  </IndexDemoComponentDemoContent>
                </div>
              </div>
              <div></div>
            </IndexDemoComponentDemoContainerDiv>
            <IndexDemoComponentUseCaseDiv>
              {usecasedata.map((item, index) => (
                <IndexDemoComponentUseCaseItemDiv
                  key={"use-case-item-" + index}
                >
                  <div>
                    <div className="use-case-item-container">
                      <div className="use-case-item-holder">
                        <div>
                          <div className="use-case-item-icon-holder">
                            {
                              item.icon
                            }
                          </div>
                        </div>
                        <div>
                          <div className="use-case-item-text-holder">
                            <p>{item.name}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </IndexDemoComponentUseCaseItemDiv>
              ))}
            </IndexDemoComponentUseCaseDiv>
          </div>
        </div>
      </div>
    </IndexDemoComponentMainDiv>
  );
};

const chathistorydata = [
  "Genarate react app",
  "Design lego game",
  "Design api Architecture ",
  "Create rest app",
  "Create rest app",
];
const usecasedata =[
  {
    name:"Code Generation",
    icon:<Bookicon/>,
  },
   {
    name:"Automated Debugging",
    icon:<Bugicon/>,
  }, {
    name:"Smart Refactoring",
    icon:<Changesicon/>,
  }, {
    name:"Codebase Exploration",
    icon:<Codebaseicon/>,
  }, {
    name:"Application Development",
    icon:<Appicon         style={{ fill: 'url(#shinyTransparentGray)' }} 
/>,
  },
]
export default IndexDemoComponent;
